import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sendInvitation } from "PFCore/services/invites/send_invitation";

import { invitesKeys } from "./query_keys";

export const useSendInvitation = (targetId: number, profileId: number) => {
  const queryClient = useQueryClient();
  const mutationKey = invitesKeys.single(targetId, profileId);

  return useMutation(
    async () => sendInvitation({ targetIds: [targetId], profileIds: [profileId], targetType: "Task" }),
    {
      mutationKey,
      onSuccess: () => queryClient.invalidateQueries({ queryKey: invitesKeys.list("Task", targetId) })
    }
  );
};
